(function () {
    'use strict';

    angular.module("imApp").factory("powTimeApprovalsService", ['$ihttp', function ($ihttp) {
        let service = {
            listApprovals: function (parms) {
                return $ihttp.post({
                    method: 1246,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
